import { createContext } from 'react';
import { IConfirmOptions } from '..';

export interface IConfirmContext {
    confirmAsync: (options: IConfirmOptions) => Promise<boolean>;
}
export const ConfirmContext = createContext<IConfirmContext | null>(null);